export const NODE_WIDTH = 200;
export const NODE_HEIGHT = 76;
export const CROWN_JEWEL_CLUSTER_NODE_ID = 'jewel:cluster';
